const convert = require("xml-js");

/**
 * Converts GPX files to JS object of coordinate
 * @param {*} gpx
 */
const gpxRteToJs = async (gpx, { recordedRoute = false } = {}) => {
	return new Promise((resolve, reject) => {
		try {
			//transform file to string:
			const reader = new FileReader();
			reader.readAsText(gpx);

			//Once the file is ready, process it:
			reader.onload = () => {
				try {
					gpx = reader.result;
					//We want to add each trkpt or wpt with x, y and time
					const coordinatesArray = [];

					//Transform GPX XML format to JS object
					let gpxObject = convert.xml2js(gpx, { compact: true }).gpx;

					//Make sure there we have a route object
					if (gpxObject.rte !== undefined && !recordedRoute) {
						if (
							gpxObject.rte.rtept.length !== undefined &&
							gpxObject.rte.rtept.length > 1
						) {
							const route = gpxObject.rte.rtept;

							//For each point get the coordinates
							route.forEach((point) => {
								coordinatesArray.push({
									x: parseFloat(point._attributes.lat),
									y: parseFloat(point._attributes.lon),
								});
							});
						} else {
							//Throw error indicating bad route
							const error = new Error(
								"La ruta debe contener más de un punto"
							);
							error.status = 400;
							error.name = "BadGPXRoute";
							throw error;
						}
						//If not try to parse a track object
					} else if (gpxObject.trk.trkseg !== undefined) {
						const segments = gpxObject.trk.trkseg;

						//If there is more than one segment
						if (
							segments.length !== undefined &&
							segments.length > 1
						) {
							//Save the points for each segment
							segments.forEach((segment) => {
								addSegmentPointsToArray(
									coordinatesArray,
									segment
								);
							});
						} else {
							//There is only one segment
							const segment = segments;
							addSegmentPointsToArray(coordinatesArray, segment);
						}
					} else {
						//Throw error indicating bad route
						const error = new Error(
							"El archivo gpx no contiene ninguna ruta"
						);
						error.status = 400;
						error.name = "BadGPXRoute";
						throw error;
					}
					//If successful conversion, resolve promise
					resolve(coordinatesArray);

					//To catch error inside
				} catch (error) {
					reject(error);
				}
			};
		} catch (error) {
			//Reject with the error in case it fails
			reject(error);
		}
	});
};

function addSegmentPointsToArray(coordinatesArray, segment) {
	//Check if there are multiple points in the segment
	if (segment.trkpt.length !== undefined && segment.trkpt.length > 1) {
		//Push all points in the segment
		segment.trkpt.forEach((point) => {
			coordinatesArray.push({
				x: parseFloat(point._attributes.lat),
				y: parseFloat(point._attributes.lon),
				time: point.time ? new Date(point.time._text) : undefined,
			});
		});
		//If only one point
	} else {
		coordinatesArray.push({
			x: parseFloat(segment.trkpt._attributes.lat),
			y: parseFloat(segment.trkpt._attributes.lon),
			time: segment.trkpt.time
				? new Date(segment.trkpt.time._text)
				: undefined,
		});
	}
}

export default gpxRteToJs;
